






































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* api */
import FieldOrderEditApi from '@/app/model/api/fieldOrderEditApi'
/* module */
import CommonClass from '@/app/module/common'
import Local from '@/app/module/local'
import { harvestStatus, routerPath, errorFlag } from '@/app/model/store/domain/const'
import RiskFunction from '@/app/module/risk'

@Component
export default class OrderModalList extends Vue {
  private isActive: boolean = true
  private isActiveStatus: boolean = false
  private status: number = 0
  private isSmall: boolean = false
  private showDialog: boolean = false
  private gradeList: Array<{[key:string]: string|number}> = []

  @Prop() private orderData!: any
  @Prop() private orderKey!: string
  @Prop() private changeStatusCheck!: number

  @Watch('changeStatusCheck')
  onIdChange (fieldId: number) {
    if (fieldId !== 0 && this.orderData.field_id === fieldId) {
      const bodyData = {
        'harvest_status': harvestStatus.ON_HOLD,
        'harvest_actual_date': null,
        'time_stamp': this.orderData.time_stamp
      }
      this.updateStatus(this.orderData.planting_harvest_instruction_id, bodyData)

      // flagをリセットする
      this.$emit('show-status-change-modal', 0)
    }
  }

  created () {
    // 等級の配列を作成
    const constantValue = JSON.parse(Local.getConstantValue()!)
    this.gradeList = constantValue.grades

    if (String(this.orderKey).indexOf('modal') !== -1) {
      this.isActiveStatus = true
    }
    this.status = this.orderData.harvest_status
  }

  private displayValue (val: string|number) {
    return val !== null && val !== undefined ? val : '-'
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-'
  }

  active () {
    this.isActive = !this.isActive
  }

  private getStatus (key: number) {
    switch (key) {
      case 0:
        return '未指示'

      case 1:
        return '保留'

      case 2:
        return '中止'

      case 3:
        return '収穫指示'

      case 4:
        return '収穫途上'

      case 5:
        return '収穫済み'

      default:
        break
    }
  }

  private getRisk (key: number) {
    switch (key) {
      case 0:
        return 'リスクなし'

      case 1:
        return 'リスクあり'

      default:
        break
    }
  }

  private afterHarvestStatus: number = 0
  /* 保留に変更 */
  private changeStatus () {
    this.$emit('show-status-change-modal', this.orderData.field_id)
  }

  /* ステータス変更API */
  private updateStatus (id: number, bodyData: any) {
    (async () => {
      const result = await FieldOrderEditApi.doUpdateStatus(id, bodyData)

      if (result.isOk()) {
        this.orderData.harvest_status = this.afterHarvestStatus
        this.orderData.harvest_actual_date = null
        const data = {
          id: id,
          time_stamp: result.getPayload().time_stamp
        }
        this.$emit('update-order-list')
        this.$emit('update-status', data)
        Vue.prototype.$alert.toast({ text: '収穫ステータスを更新しました。', type: 0 })
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
        if (errorData.status_code === '409') {
          this.$emit('show-error409-modal')
        } else {
          this.$emit('show-error-info', '収穫ステータス更新に失敗しました。')
        }
      }
    })()
  }

  /* 全てのアコーディオンを開く */
  public modalAllExpand (id: number, isOpen: boolean) {
    let getAllToggles = document.getElementsByClassName('modal-toggle-btn')
    let $el: HTMLElement = getAllToggles[id] as HTMLElement

    if (!isOpen) {
      // 閉じる
      if ($el.getAttribute('aria-expanded') === 'false') {
        return
      }
      $el.click()
    } else {
      // 開く
      if ($el.getAttribute('aria-expanded') === 'true') {
        return
      }
      $el.click()
    }
  }

  /* 全てのアコーディオンを閉じる */
  public modalAllClose (id: number) {
    let getAllToggles = document.getElementsByClassName('modal-toggle-btn')
    let $el: HTMLElement = getAllToggles[id] as HTMLElement

    let element: any = $el
    if (element.getAttribute('aria-expanded') !== null && element.getAttribute('aria-expanded') !== 'false') {
      $el.click()
    }
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    if (num === null) {
      return '-'
    } else {
      return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }

  /* 文字数が多い場合はフォントを縮める */
  public fixFontSize (val: any) {
    if (val.length > 20) {
      this.isSmall = true
    }
    return val
  }

  private createYYYYmmdd (e: any) {
    return e.slice(0, 10)
  }

  private displayFixedRisk (risk: any): string {
    return RiskFunction.displayFixedRisk(risk)
  }
  private displayOtherRisk (risk: any): string {
    return RiskFunction.displayOtherRisk(risk)
  }
}
